import React, { FC, useState } from 'react';
import styles from './CardSection.module.less';
import { Col, Row, Spin } from 'antd';
import { Card } from 'components/EarnAndStake';
import { FilterGroup } from 'components/FilterGroup';
import { useTypeSafeTranslation } from 'hooks/useTypeSafeTranslation';
import { setEarnModal, setSelectedStakeInfo } from 'store/ducks/stake/slice';
import { useEarnInfo } from '../hooks/useEarnInfo';
import { useAppDispatch, useAppSelector } from 'hooks';
import { IStakingInfo } from 'api/staking';
import { useUser } from '@auth0/nextjs-auth0';
import { setAuthModal } from 'store/ducks/system/slice';
import { MAIN_ACCOUNT_KEY, getCurrentSubAccount } from 'store/ducks/sub_account/slice';

const CardSection: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTypeSafeTranslation();
  const { user } = useUser();
  const [filter, setFilter] = useState<'popular' | 'APY'>('popular');

  const { data, isLoading, getStakeInfoByMaxAPY, getStakeAPYRange } = useEarnInfo();

  const handleEarn = (data: IStakingInfo, coin: string) => {
    if (!user) {
      return dispatch(setAuthModal({ type: 'auth', screen: 'earn' }));
    }

    dispatch(setSelectedStakeInfo({ ...data, coin }));
    dispatch(setEarnModal(true));
  };
  const currentSub = useAppSelector(getCurrentSubAccount);

  const isDisabledStakeAndEarn = currentSub !== MAIN_ACCOUNT_KEY;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1>{t('stake.ult_earn_title')}</h1>
        <p>{t('stake.ult_earn_sub_title')}</p>
      </div>

      <div className={styles.body}>
        <div className={styles.filterGroup}>
          <FilterGroup
            datas={[
              { label: t('stake.popular'), value: 'popular' },
              { label: t('stake.max_apy'), value: 'APY' },
            ]}
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>

        {isLoading && (
          <div className="f-center">
            <Spin />
          </div>
        )}

        <Row justify="center" gutter={[24, 32]} className={styles.cardWrap}>
          {Object.keys(data).map((item) => (
            <Col xs={12} sm={12} md={6} lg={6} key={item}>
              <Card
                isDisabledStakeAndEarn={isDisabledStakeAndEarn}
                data={getStakeInfoByMaxAPY(data[item])}
                coin={item}
                apyRange={getStakeAPYRange(data[item])}
                type="earn"
                onClick={handleEarn}
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default CardSection;
